import { faTableColumns } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useRef, useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setTableColumnSelection } from '../../store/redux-slices/uiConfig'
import './TableColumnSelection.css'

const TableColumnSelection = ({ id }) => {
  const dispatch = useDispatch()
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null)
  const columnSelectionsFromStore = useSelector((state) => state?.uiConfig?.tableColumnSelections[id] || [])

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false)
    }
  }

  const onChangeColumnSelection = (changedColumn) => {
    dispatch(setTableColumnSelection({
      id,
      columnSelections: columnSelectionsFromStore.map((column) => {
        if (column.id === changedColumn.id) {
          return { ...column, show: !column.show }
        }
        return column
      })
    }))
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="table-column-selection" style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Dropdown show={showDropdown} ref={dropdownRef} onToggle={() => setShowDropdown(!showDropdown)}>
        <Dropdown.Toggle id='dropdown-basic-button' onClick={() => setShowDropdown(!showDropdown)} className='table-column-selection-button'>
          Select Columns
          <FontAwesomeIcon icon={faTableColumns} style={{ marginLeft: '10px' }} />
        </Dropdown.Toggle>
        <Dropdown.Menu align='end' onClick={(e) => e.stopPropagation()}>
          {columnSelectionsFromStore.reduce((previousValue, currentValue) => {
            if (!currentValue.required) {
              return [...previousValue, (
                <Dropdown.Item key={currentValue.id} as='div' onClick={(e) => e.stopPropagation()}>
                  <label className='dropdown-item'>
                    <input
                      type='checkbox'
                      className='banned-games-checkbox'
                      checked={currentValue.show}
                      onChange={() => onChangeColumnSelection(currentValue)}
                    />
                    {currentValue.label}
                  </label>
                </Dropdown.Item>
              )]
            }
            return previousValue
          }, [])}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default TableColumnSelection
